var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_12151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7624 10.9107L1.76241 10.9106L10.0982 2.57483V7.89467C10.0982 8.15748 10.3113 8.37055 10.5741 8.37055C10.8369 8.37055 11.05 8.15748 11.05 7.89467V1.42588C11.05 1.16307 10.8369 0.949978 10.5741 0.95H4.10533C3.84252 0.95 3.62945 1.16307 3.62945 1.42588C3.62945 1.68869 3.84252 1.90176 4.10533 1.90176H9.42525L1.08939 10.2376C0.903536 10.4235 0.903536 10.7248 1.08939 10.9106L1.0894 10.9107C1.18233 11.0035 1.30417 11.05 1.4259 11.05C1.54763 11.05 1.66947 11.0035 1.7624 10.9107Z",
    fill: "#686868",
    stroke: "#686868",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_12151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestIcon);
export default __webpack_public_path__ + "static/media/invest_icon.2d187e7e94b87325fae6022da69f0941.svg";
export { ForwardRef as ReactComponent };